// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"365":"98ef6d5e","871":"b207af8c"}[chunkId] + ".css";
};